module.exports = __webpack_public_path__ + "media/images/categories/headers/industries-57de44a7acc90c214eb7a1d3d7668d53.jpg";